import { render } from "./form-add-role.vue?vue&type=template&id=50c17720"
import script from "./form-add-role.vue?vue&type=script&lang=js"
export * from "./form-add-role.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__